import Instance from "../axios/Instance";

export const signin = (login) => {
    return Instance.post('/auth/signin', login).then(response => response);
}
export const signout = () => {
    return Instance.post('/auth/signout').then(response => response);
}
export const checkSession = () => {
    return Instance.get('/auth/checksession').then(response => response);
}
